module.exports = __webpack_public_path__ + "img/hotel_thumbnail.e1afdff7.jpg";